import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';

@Component({
  selector: 'app-edit-subscription-feature-assign',
  templateUrl: './edit-subscription-feature-assign.component.html',
  styleUrls: ['./edit-subscription-feature-assign.component.css']
})
export class EditSubscriptionFeatureAssignComponent extends BaseComponent implements OnInit {
  customer_id;
  editAssignForm: FormGroup;
  getCompanyobj: any = [];
  submitted = false;
  selectedCompany: any = '';
  subsObj: any = [];
  featureObj: any = [];
  assign_id: any;
  assignRecord: any = [];
  constructor(
    private formBuilder: FormBuilder,
    private clientsService: ClientService,
    private masterService: MasterService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.customer_id = JSON.parse(sessionStorage.getItem('userData')).admin_customer_id;
    if (this.customer_id == 0) this.getCompany();

    if (localStorage.getItem("edit_subscription_feature_assign_id")) {
      this.assign_id = localStorage.getItem("edit_subscription_feature_assign_id");
      this.selectedCompany = localStorage.getItem("subscription_feature_assign_edit_company_id");

      this.masterService.getSubscriptionFeatureValueById(this.selectedCompany, this.assign_id).subscribe(response => {
        if (response.status) {
          this.assignRecord = response.data;
          this.dataBinding();
        }
      });
    }

    this.editAssignForm = this.formBuilder.group({
      selectedCompany: [this.selectedCompany],
      sub_id: ['', [Validators.required]],
      feature_id: ['', [Validators.required]],
      feature_value: ['', [Validators.required, Validators.maxLength(100)]]
    });

    this.loadDropdowns();
  }

  dataBinding() {
    this.editAssignForm = this.formBuilder.group({
      selectedCompany: [this.selectedCompany],
      sub_id: [this.assignRecord.sub_id, [Validators.required]],
      feature_id: [this.assignRecord.feature_id, [Validators.required]],
      feature_value: [this.assignRecord.feature_value, [Validators.required, Validators.maxLength(100)]]
    });
  }

  getCompany() {
    let self = this;
    this.clientsService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      self.hydrateWorkingCompany(self, (id) => { self.loadDropdowns(); });

    }, error => {
      console.log(error);
    });
  }

  loadDropdowns() {
    if (this.selectedCompany !== "") {
      this.ngxSpinnerService.show();
      this.masterService.getSubscriptionListDropdown(this.selectedCompany, 1000, 0).subscribe(data => {
        if (data.status) {
          if (data.data.rows == null) { this.subsObj = [] }
          else { this.subsObj = data.data.rows }
        } else {
          this.subsObj = [];
        }
      }, error => { console.log(error); });
      this.masterService.getSubscriptionFeatureList(this.selectedCompany, 1000, 0, '', 'order_no', 'asc').subscribe(data => {
        this.ngxSpinnerService.hide();
        if (data.status) {
          if (data.data.rows == null) { this.featureObj = [] }
          else { this.featureObj = data.data.rows }
        } else {
          this.featureObj = [];
        }
      }, error => { console.log(error); this.ngxSpinnerService.hide(); });
    } else {
      this.subsObj = [];
      this.featureObj = [];
      this.ngxSpinnerService.hide();
    }
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  get f() { return this.editAssignForm.controls; }

  editNewAssignData() {
    this.submitted = true;
    if (this.editAssignForm.invalid) {
      return;
    }
    let { sub_id, feature_id, feature_value } = this.editAssignForm.value;
    let obj = {
      sub_id: sub_id,
      feature_id: feature_id,
      feature_value: feature_value
    }
    this.masterService.updateSubscriptionFeatureValue(this.selectedCompany, this.assign_id, obj).subscribe(data => {
      if (data.status) {
        this.toastrService.success("Feature assignment updated successfully");
        this.router.navigateByUrl(`/corporate/subscription-feature-assign`);
      } else {
        this.toastrService.error(data.message);
      }
    }, error => {
      this.toastrService.error(error.message);
    });
  }
}
